import { Grid } from 'antd';
import type { Breakpoint } from 'antd';

/**
 * 参考antd grid布局边界值
 * @returns 布局方向
 */
export function useBreakpoint(): Partial<Record<Breakpoint, boolean>> {
  /**
   * windowInnerWidth >= 768px  true
   * windowInnerWidth < 768px false
   *
   * md 是 768px
   * lg 是 992px
   */
  const { md, lg } = Grid.useBreakpoint();

  return {
    md,
    lg
  };
}
